export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const SOCIAL_AUTH_REQUEST = 'SOCIAL_AUTH_REQUEST'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const USER_REQUEST = 'USER_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_ERROR = 'USER_ERROR'
export const USER_REGISTER = 'USER_REGISTER'
export const USER_SET_PROFILE = 'USER_SET_PROFILE'
export const USER_LOAD = 'USER_LOAD'
export const USER_LOAD_REQUEST = 'USER_LOAD_REQUEST'
export const USER_LOAD_SUCCESS = 'USER_LOAD_SUCCESS';
export const USER_LOAD_ERROR = 'USER_LOAD_ERROR';
export const USER_GALLERY_VIDEO_LOAD = 'USER_GALLERY_VIDEO_LOAD'
export const USER_GALLERY_VIDEO_LOAD_REQUEST = 'USER_GALLERY_VIDEO_LOAD_REQUEST'
export const USER_GALLERY_VIDEO_LOAD_SUCCESS = 'USER_GALLERY_VIDEO_LOAD_SUCCESS';
export const USER_GALLERY_VIDEO_LOAD_ERROR = 'USER_GALLERY_VIDEO_LOAD_ERROR';
export const USER_GALLERY_IMAGES_LIST = 'USER_GALLERY_IMAGES_LIST'
export const USER_GALLERY_IMAGES_LIST_REQUEST = 'USER_GALLERY_IMAGES_LIST_REQUEST'
export const USER_GALLERY_IMAGES_LIST_SUCCESS = 'USER_GALLERY_IMAGES_LIST_SUCCESS';
export const USER_GALLERY_IMAGES_LIST_ERROR = 'USER_GALLERY_IMAGES_LIST_ERROR';
export const USER_GALLERY_IMAGE = 'USER_GALLERY_IMAGE'
export const USER_GALLERY_IMAGE_REQUEST = 'USER_GALLERY_IMAGE_REQUEST'
export const USER_GALLERY_IMAGE_SUCCESS = 'USER_GALLERY_IMAGE_SUCCESS';
export const USER_GALLERY_IMAGE_ERROR = 'USER_GALLERY_IMAGE_ERROR';

export const STATS_LOAD = 'STATS_LOAD'
export const STATS_LOAD_REQUEST = 'STATS_LOAD_REQUEST'
export const STATS_LOAD_SUCCESS = 'STATS_LOAD_SUCCESS';
export const STATS_LOAD_ERROR = 'STATS_LOAD_ERROR';

export const USER_SEND = 'USER_SEND';
export const USER_SEND_PATCH = 'USER_SEND_PATCH';
export const USER_SEND_REQUEST = 'USER_SEND_REQUEST';
export const USER_SEND_SUCCESS = 'USER_SEND_SUCCESS';
export const USER_SEND_ERROR = 'USER_SEND_ERROR';
export const USER_DELETE = 'USER_DELETE';
export const USER_DELETE_REQUEST = 'USER_DELETE_REQUEST';
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS';
export const USER_DELETE_ERROR = 'USER_DELETE_ERROR';
export const IMAGE_DELETE = 'IMAGE_DELETE';
export const IMAGE_DELETE_REQUEST = 'IMAGE_DELETE_REQUEST';
export const IMAGE_DELETE_SUCCESS = 'IMAGE_DELETE_SUCCESS';
export const IMAGE_DELETE_ERROR = 'IMAGE_DELETE_ERROR';
export const VIDEO_DELETE = 'VIDEO_DELETE';
export const VIDEO_DELETE_REQUEST = 'VIDEO_DELETE_REQUEST';
export const VIDEO_DELETE_SUCCESS = 'VIDEO_DELETE_SUCCESS';
export const VIDEO_DELETE_ERROR = 'VIDEO_DELETE_ERROR';
export const USER_IMG_SEND = 'USER_IMG_SEND';
export const USER_IMG_SEND_REQUEST = 'USER_IMG_SEND_REQUEST';
export const USER_IMG_SEND_SUCCESS = 'USER_IMG_SEND_SUCCESS';
export const USER_IMG_SEND_ERROR = 'USER_IMG_SEND_ERROR';
export const USER_GALLERY_VIDEO_SEND = 'USER_GALLERY_VIDEO_SEND';
export const USER_GALLERY_VIDEO_SEND_REQUEST = 'USER_GALLERY_VIDEO_SEND_REQUEST';
export const USER_GALLERY_VIDEO_SEND_SUCCESS = 'USER_GALLERY_VIDEO_SEND_SUCCESS';
export const USER_GALLERY_VIDEO_SEND_ERROR = 'USER_GALLERY_VIDEO_SEND_ERROR';
export const USER_AVATAR_LOAD = 'USER_AVATAR_LOAD';
export const USER_AVATAR_LOAD_REQUEST = 'USER_AVATAR_LOAD_REQUEST';
export const USER_AVATAR_LOAD_SUCCESS = 'USER_AVATAR_LOAD_SUCCESS';
export const USER_AVATAR_LOAD_ERROR = 'USER_AVATAR_LOAD_ERROR';
export const USER_PROFILE_LOAD = 'USER_PROFILE_LOAD';
export const USER_PROFILE_LOAD_REQUEST = 'USER_PROFILE_LOAD_REQUEST';
export const USER_PROFILE_LOAD_SUCCESS = 'USER_PROFILE_LOAD_SUCCESS';
export const USER_PROFILE_LOAD_ERROR = 'USER_PROFILE_LOAD_ERROR';
export const USER_RESET_EMAIL = 'USER_RESET_EMAIL'
export const USER_CHANGE_PASSWORD = 'USER_CHANGE_PASSWORD'
export const USER_RESET_PASSWORD = 'USER_RESET_PASSWORD'
export const USER_CONFIRM_EMAIL = 'USER_CONFIRM_EMAIL'
export const SET_PROFILE_IMAGE = 'SET_PROFILE_IMAGE';
export const POST_SEND = 'POST_SEND';
export const POSTS_LOAD_BB = 'POSTS_LOAD_BB';
export const UPLOADS_LOAD_VIDEO = 'UPLOADS_LOAD_VIDEO';
export const VIDEO_TREE_LOAD = 'VIDEO_TREE_LOAD';
export const UPLOADS_SAVE_HASH_TAG = 'UPLOADS_SAVE_HASH_TAG';
export const POSTS_LOAD_COUNT = 'POSTS_LOAD_COUNT';
export const POSTS_LOAD_IMAGE = 'POSTS_LOAD_IMAGE';
export const POSTS_LOAD = 'POSTS_LOAD';
export const POSTS_REQUEST = 'POSTS_REQUEST';
export const POSTS_SUCCESS = 'POSTS_SUCCESS';
export const POSTS_ERROR = 'POSTS_ERROR';
export const UPLOADS_REQUEST = 'UPLOADS_REQUEST';
export const UPLOADS_SUCCESS = 'UPLOADS_SUCCESS';
export const UPLOADS_ERROR = 'UPLOADS_ERROR';
export const UPLOADS_SAVE_HASH_TAG_REQUEST = 'UPLOADS_SAVE_HASH_TAG_REQUEST';
export const UPLOADS_SAVE_HASH_TAG_SUCCESS = 'UPLOADS_SAVE_HASH_TAG_SUCCESS';
export const UPLOADS_SAVE_HASH_TAG_ERROR = 'UPLOADS_SAVE_HASH_TAG_ERROR';
export const VIDEO_TREE_REQUEST = 'VIDEO_TREE_REQUEST';
export const VIDEO_TREE_SUCCESS = 'VIDEO_TREE_SUCCESS';
export const VIDEO_TREE_ERROR = 'VIDEO_TREE_ERROR';
export const POSTS_SEND_REQUEST = 'POSTS_SEND_REQUEST';
export const POSTS_SEND_SUCCESS = 'POSTS_SEND_SUCCESS';
export const POSTS_SEND_ERROR = 'POSTS_SEND_ERROR';
export const POST_DELETE = 'POST_DELETE';
export const USER_SEARCH = 'USER_SEARCH';
export const USER_SEARCH_REQUEST = 'USER_SEARCH_REQUEST';
export const USER_SEARCH_SUCCESS = 'USER_SEARCH_SUCCESS';
export const USER_SEARCH_ERROR = 'USER_SEARCH_ERROR';
